<template>
  <div class="row question mt-2 mb-2 text-center">
    <div class="col-12">
      <div class="radio">
        <div
          class="radio__item"
          v-for="(label, index) in labels"
          :key="index"
        >
          <input
            @click="handleClick($event, label.text)"
            @keyup.enter="handleEnter($event, label.text)"
            :id="label.text + '-' + id"
            :name="id"
            type="radio"
            :value="label.value"
            :checked="isChecked(label.value)"
          />
          <label
            v-text="label.text === 'psim' ? 'Physical Sim' : 'Coming Soon'"
            class="radio__label sim-btn-2"
            :for="label.text + '-' + id"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';

const props = defineProps({
  mobile_form: Object,
  id: String,
  labels: Array,
  error: String,
  errors: Object,
  icon: String,
});

const emit = defineEmits(["checkValue"]);

const handleClick = (event, text) => {
  if (text === 'esim') {
    event.preventDefault();
  } else {
    updateFormValue(event.target.value);
  }
};

const handleEnter = (event, text) => {
  if (text !== 'esim') {
    updateFormValue(event.target.value);
  } else {
    event.preventDefault();
  }
};

const updateFormValue = (value) => {
  props.mobile_form[props.id] = value;
  emit('checkValue', 'clicked');
};

const isChecked = (value) => {
  return props.mobile_form[props.id] === value;
};
</script>

<style lang="scss">
// @import "../styles/_variables.scss";

.radio {
  display: flex;
  flex-wrap: wrap;

  &__item {
    position: relative;
    padding: 0 5px 10px;
    width: 50%;

    @media only screen and (max-width: 768px) {
      width: 50%;
      padding: 0 5px 5px;
    }
  }

  & label,
  input {
    font-size: 14px;
    padding: 15px;
    width: 100%;
    border: 2px solid #100c2f;

    @media only screen and (min-width: 500px) {
      padding: 5px 5px;
      font-size: 15px;
    }

    @media only screen and (max-width: 768px) {
      padding: 5px;
    }
  }

  & input[type="radio"] {
    opacity: 0;
    height: 0;
    position: absolute;
  }

  & input[type="radio"]:checked + label {
    background: blue;
    color: white;
    
    & > svg {
      color: white;
    }
  }

  & input[type="radio"]:hover + label {
    background: blue;
    color: white;

    & > svg {
      color: white;
    }
  }

  & label {
    height: 100%;
    cursor: pointer;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: black;
    height: 55px;
    border: none;

    @media only screen and (max-width: 768px) {
      height: 46px;
    }
  }
}

.sim-btn-2 {
    border: 2px solid black!important;
}
</style>
